import Stepper from 'antd-mobile/lib/stepper/index';
export default Stepper;



// WEBPACK FOOTER //
// ./components/stepper/index.tsx